module.exports = __webpack_public_path__ + "static/media/4.1f20abf2.jpg";